// Helper method to check if total file size exceeds the specified limit
export function isFileSizeExceeded(maxSizeInMB: number, files: Array<File>): boolean {
  const maxFileSize = maxSizeInMB * 1024 * 1024;
  const totalSize = files.reduce((sum, file) => sum + file.size, 0);
  return totalSize > maxFileSize;
}
